export default __webpack_public_path__ + "static/media/GarlicBread.cf9ed4e3.jpg";